"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toHeadnoteSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toHeadnoteSlice = function (data, logger) {
    var _a, _b, _c;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Headnote)), { text: logger.required(fields_1.toRichText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.text, logger)), title: fields_1.toText((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.title), image: fields_1.toImage((_c = data === null || data === void 0 ? void 0 : data.primary) === null || _c === void 0 ? void 0 : _c.image, logger) }));
};
exports.toHeadnoteSlice = toHeadnoteSlice;
//# sourceMappingURL=headnote-slice.js.map